import { render, staticRenderFns } from "./PaywallDialog.vue?vue&type=template&id=53b81a76"
import script from "./PaywallDialog.vue?vue&type=script&lang=js"
export * from "./PaywallDialog.vue?vue&type=script&lang=js"
import style0 from "./PaywallDialog.vue?vue&type=style&index=0&id=53b81a76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports